
export default theme => ({

  paper: {
    marginTop: theme.spacing(8),
    padding: theme.spacing(2),
    width: '100%',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'grey',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
    padding: '15px',
    paddingTop: '40px',
    paddingBottom: '40px'
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
    link: {
    textDecoration: 'none',
    color: "white",
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
});